/**
 * @enum {String}
 */
export const SOCIALS = {
  telegram: 'telegram',
  facebook: 'facebook',
  twitter: 'twitter',
};
